import styled from 'styled-components';

import theme from '@theme';

export const Wrapper = styled.div`
  display: flex;
  background-size: cover;
  background-image: url('/static/images/gsf-searchbar-bg.jpg');
  background-position: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 30px 15px;
  background-position: top;
`;
export const Title = styled.div`
  color: #fff;
  font-size: 39px;
  font-weight: 400;
  margin: 0 0 35px;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  text-shadow: 0 0 5px black;
`;

export const Center = styled.div`
  text-align: center;
`;

export const TabWrapper = styled.div`
  width: 100%;
`;

export const TabItemWrapper = styled.div`
  background-color: #434343cc;
  padding: 10px 20px 20px 20px;
  color: white;
  min-height: 215px;
`;

export const TabMenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  white-space: nowrap;
  scroll-behavior: smooth;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Safari ve Chrome */
  }

  @media (max-width: ${theme.breakPoint.TABLET}) {
    margin: 0px 20px;
  }

  @media (max-width: ${theme.breakPoint.PHONE}) {
    margin: 0px 20px;
  }
`;

export const TabMenuScroll = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -54px;
  z-index: 99999;
`;

export const ScrollButtonLeft = styled.div`
  height: 54px;
  width: 30px;
  background-color: #434343;
  cursor: pointer;
  text-align: center;
  padding-top: 17px;
  color: white;
  border: 1px solid #666;
`;

export const ScrollButtonRight = styled.div`
  height: 54px;
  width: 30px;
  background-color: #434343;
  cursor: pointer;
  text-align: center;
  padding-top: 17px;
  color: white;
  border: 1px solid #666;
`;

export const TabMenuItem = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  background-color: ${({ isActive }) => (isActive ? '#434343CC' : '#ebebeb')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#434343 ')};
  width: 175px;
  height: 54px;
  padding: 14px 24px 12px 24px;
  font-size: 17px;
  font-weight: 600;
  :hover {
    background-color: #434343;
    color: #fff;
    cursor: pointer;
  }
`;

export const IconWrapper = styled.div<{ rotate?: boolean }>`
  margin: 0px 10px 0px 20px;
  transform: ${({ rotate }) => (rotate ? 'rotate(45deg)' : 'none')};
`;

export const TextWrapper = styled.div`
  :hover {
    color: #fff;
  }
`;

export const TabItemSubWrapper = styled.div<{ tabValue: number }>`
  margin-top: ${({ tabValue }) => (tabValue === 1 ? '0px' : '38px')};
`;
